import { Box, RadioProps, useRadio } from '@chakra-ui/react'
import theme from 'theme'

interface Props extends RadioProps {
  checkedUnderline?: boolean;
}

export const CustomRadio = ({ checkedUnderline = false, ...props }: Props) => {
  const { getInputProps, getRadioProps } = useRadio(props)
  const input = getInputProps()
  const checkbox = getRadioProps()
  const activeStyles = Object.assign(
    { color: theme.colors.saffronSunset, fontWeight: 500 },
    checkedUnderline
      ? {
          borderBottom: 'solid 3px',
          borderBottomColor: theme.colors.saffronSunset,
        }
      : {}
  )

  return (
    <Box as="label">
      <input {...input} />
        <Box {...checkbox} suppressHydrationWarning={true} fontWeight={300} _checked={activeStyles}>
        {props.children}
        </Box>
    </Box>
  )
}
